import React from 'react'
import './Designer2.scss';

let Designer;

export default class DeferredDesigner extends React.Component{
  state = {
    fetchingBundle: true
  }
  componentDidMount = () => {
    this.fetchDesignerBundle()
  }
  fetchDesignerBundle = () => {
    import('./Designer2')
      .then((designer2) => {
        Designer = designer2.default
        this.setState({ fetchingBundle: false })
      })
      .catch((e) => {
        console.error(e)
      })
  }
  render(){
    return(
      this.state.fetchingBundle ?
      null
      :
      <Designer {...this.props} />
    )
  }
}
